
<div class="d-flex flex-column p-5">
    <div class="row justify-content-around"><h2>Updating user progress</h2></div>
</div>
<div class="d-flex flex-column p-5">
    <div class="row justify-content-around"><h4>Mapped Metadata: {{ usersMeta.length }}</h4></div>
</div>
<div class="d-flex w-98 row justify-content-center">
    <button class="btn btn-primary" (click)="start()">Start</button>
</div>
<div *ngIf="isFinished" class="d-flex flex-column p-5">
    <div class="row justify-content-around"><h5>Succsessful migrations: {{ usersTransformArr.length }}</h5></div>
    <div class="row justify-content-around"><h5>Failed migrations: {{ failedUsersTransformArr.length }}</h5></div>
</div>
